<template>
    <div>
    <el-popover trigger="hover" placement="top">
        <template>
             <el-table ref="processTable" :data="processInstanceList" style="width: 100%" :border="true">
                <el-table-column prop="processInstanceName" width="200" label="流程名称" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                      <el-tag v-if="scope.row.processInstanceStatus === 4 " type="warning" size="small">已终止</el-tag> {{ scope.row.processInstanceName }}
                 </template>
                </el-table-column>
                <!-- <el-table-column prop="processInstanceType" label="业务流类型" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.processInstanceType === '1' || scope.row.processInstanceType === '3' " type="primary" size="small">含子流程</el-tag>
                        <el-tag v-if="scope.row.processInstanceType === '2' " type="success" size="small">子流程</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="processDefinitionName" label="关联流程定义" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="assigneeUserName" label="流程负责人" width="100"></el-table-column> -->
                <el-table-column prop="createdByName" label="发起人" width="70"></el-table-column>
                <el-table-column prop="createdDate" label="发起时间" :sortable="true" width="150"></el-table-column>
                <el-table-column   label="操作">
                  <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-view" title="流程详情" circle @click="checkProcessDetail(scope.row.processInstanceId)"></el-button>
                  </template>
                </el-table-column>
            </el-table>
        </template>
        <div slot="reference" class="name-wrapper">
            <el-tag  type="warning" size="medium"> <el-tag v-if=" processInstanceStatus === 4 " type="danger" size="small">已终止</el-tag> {{ cellValue }}</el-tag>
        </div>
    </el-popover>
     <el-dialog
          title="流程详情"
          :fullscreen="true"
          append-to-body
          :visible.sync="isShowProcessInstanceDetail"
          >
         <ProcessDetail
            v-if="isShowDetail"
            :key="loadTimer"
            :instances="instancesInfo"
            :isRead="true"
          />
        </el-dialog>
    </div>
</template>

<script>
import ProcessDetail from '@/pages/process/MyProcess/ProcessDetail';
import { getProcessInstancesDetail, getProcessInstancesUsers } from '@/data-model';
export default {
    components: {
        ProcessDetail
    },
    data () {
        return {
            processInstanceList: [],
            loadTimer: '',
            isShowDetail: false,
            isShowProcessInstanceDetail: false,
            instancesInfo: {}
        };
    },
    props: {
        isShowOverflowTooltip: {
            type: Boolean,
            default: false
        },
        column: {
            type: Object
        },
        cellValue: {
            type: String,
            default: ''
        },
        processInstanceName: {
            type: String,
            default: ''
        },
        processInstanceId: {
            type: String,
            default: ''
        },
        createdByName: {
            type: String,
            default: ''
        },
        createdDate: {
            type: String,
            default: ''
        },
        processInstanceStatus: {
            type: Number,
            default: 0
        }
    },
    created () {
        this.isShowProcessInstanceDetail = false;
        this.processInstanceList = [];
        let processObj = { processInstanceId: this.processInstanceId, processInstanceName: this.processInstanceName, createdByName: this.createdByName, createdDate: this.createdDate, processInstanceStatus: this.processInstanceStatus };
        this.processInstanceList.push(processObj);
    },
    methods: {
        async  checkProcessDetail (processInstanceId) {
            // 1.判断查看所有流程
            let res = this.viewTaskAuth();
            if (!res) { // 没有查看全部流程的权限
                let res = await getProcessInstancesUsers({processInstanceId: processInstanceId});
                if (!res.isHashCurUser) {
                    this.$message.error('你没有参与此流程并且没有查看权限');
                } else {
                    this.showProcessDetail(processInstanceId);
                }
            } else {
                this.showProcessDetail(processInstanceId);
            }
        },
        async showProcessDetail (processInstanceId) {
            this.isShowDetail = false;
            this.loadTimer = new Date().getTime();
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.instancesInfo = await getProcessInstancesDetail(processInstanceId);
            if (this.instancesInfo) {
                this.isShowDetail = true;
                this.isShowProcessInstanceDetail = true;
            } else {
                // 流程不存在或者已删除
                this.$message.error('该流程查询不到或已被删除！');
            }
            loading.close();
        },
        viewTaskAuth () {
            let isEditAuth = false;
            let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
            if (currentUserStr) {
                let currentUserInfo = JSON.parse(currentUserStr);
                let resources = currentUserInfo.resources;
                if (resources) {
                    for (let i = 0; i < resources.length; i++) {
                        if (resources[i].resourceUrl === 'AllProcessInstanceData') { // 是否可以查看所有流程(同时也包括查看非自己负责的所有任务)
                            isEditAuth = true;
                            break;
                        }
                    }
                }
            }
            return isEditAuth;
        }
    }
};
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/DynamicTable/DynamicProcessColumn.vue